import { createAdminAPIClient } from "@shopware/api-client";

declare module '#app' {
    interface NuxtApp {
        $adminApiEndpoint: string,
        $adminApiClient: any,
        $adminGetAccessData(): any
    }
}

export default defineNuxtPlugin((NuxtApp)=> {
    const runtimeConfig = useRuntimeConfig();
    const apiEndPoint = runtimeConfig.public?.endpoint ?
        runtimeConfig.public.endpoint.replace("store-api/", "api") : 'no_endpoint';

    // Create a fresh client per plugin invocation (per request in SSR)
    const adminApiClient = createAdminAPIClient({
        baseURL: apiEndPoint,
        sessionData: {},
        defaultHeaders: {
            'sw-include-seo-urls': '1',
        }
    });

    const login = () => {
        return adminApiClient.invoke("token post /oauth/token", {
            body: {
                grant_type: "client_credentials",
                client_id: runtimeConfig.app.api_client_id,
                client_secret: runtimeConfig.app.api_client_secret,
            }
        });
    };

    const getAccessData = async ()=> {
        return await login();
    }

    NuxtApp.provide("adminApiClient", adminApiClient);
    NuxtApp.provide("adminApiEndpoint", apiEndPoint);
    NuxtApp.provide("adminGetAccessData", getAccessData);
});
